import { Component } from '@angular/core';
@Component({
  selector: 'twaice-fe-sub-page',
  templateUrl: './sub-page.component.html',
  styleUrls: ['./sub-page.component.scss'],
  standalone: false,
})
export class SubPageComponent {}
